import * as React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import './Graph.scss'

function getDailyData(data: [string, string][]) {
  return data
    .map(d => [new Date(d[0]).getTime(), parseFloat(d[1])])
    .sort((a, b) => a[0] - b[0])
}

function getMonthlyData(data: [string, string][]) {
  const monthlyData: {[time: string]: number} = {}
  data
    .forEach(d => {
      const monthStart = d[0].split("-").slice(0, 2).join("-") + "-01"
      monthlyData[monthStart] ?
        monthlyData[monthStart] += parseFloat(d[1]) :
        monthlyData[monthStart] = parseFloat(d[1])
    })
  return Object.keys(monthlyData)
    .map(k => [new Date(k).getTime(), monthlyData[k]])
    .sort((a, b) => a[0] - b[0])
}

const monthMap: {[month: string]: string} = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "Jun",
  "07": "Jul",
  "08": "Aug",
  "09": "Sep",
  "10": "Oct",
  "11": "Nov",
  "12": "Dec"
}

function getCompareMonthlyDate(data: [string, string][], year: string) {
  const compareData: {[time: string]: number} = {}
  data
    .forEach(d => {
      const date = d[0].split("-")[1]
      const dateYear = d[0].split("-")[0]
      if (dateYear === year) {
        compareData[date] ?
          compareData[date] += parseFloat(d[1]) :
          compareData[date] = parseFloat(d[1])
      }
    })
  return Object.keys(compareData)
  .sort((a, b) => a.localeCompare(b))
  .map(k => [monthMap[k], compareData[k]] as [string, number])
}

function getOptions(data: [string, string][], aggregate?: boolean) {
  return {
    chart: {
      scrollablePlotArea: {
        minWidth: 1024
      }
    },
    credits: false,
    title: {
      text: ''
    },
    xAxis: {
      type: 'datetime'
    },
    yAxis: {
      title: null
    },
    series: [{
      color: '#0066cc',
      type: 'column',
      data: aggregate ? 
        getMonthlyData(data) :
        getDailyData(data),
      pointWidth: undefined,
      pointPadding: 0,
      groupPadding: 0,
      name: 'Yield',
      tooltip: {
        valueSuffix: ' Wh'
      }
    }]
  }
}

function getCompareOptions(data: [string, string][], year: string, aggregate?: boolean) {
  const lastYear = (parseInt(year) - 1).toString()
  return {
    chart: {
      scrollablePlotArea: {
        minWidth: 1024
      }
    },
    credits: false,
    title: {
      text: ''
    },
    xAxis: {
      type: 'category'
    },
    yAxis: {
      title: null
    },
    series: [{
      color: 'red',
      type: 'column',
      data: aggregate ? 
        getCompareMonthlyDate(data, lastYear) :
        getDailyData(data),
      pointWidth: undefined,
      pointPadding: 0,
      groupPadding: 0,
      name: 'Yield ' + lastYear,
      tooltip: {
        valueSuffix: ' Wh'
      }
    },{
      color: '#0066cc',
      type: 'column',
      data: aggregate ? 
      getCompareMonthlyDate(data, year) :
        getDailyData(data),
      pointWidth: undefined,
      pointPadding: 0,
      groupPadding: 0,
      name: 'Yield ' + year,
      tooltip: {
        valueSuffix: ' Wh'
      }
    }]
  }
}

interface Props extends HighchartsReact.Props {
  data: [string, number][],
  selectedYear: string
}

export const Graph = (props: HighchartsReact.Props) => <div className="graph-container">
    <HighchartsReact
        highcharts={Highcharts}
        options={getOptions(props.data)}
        {...props}
    />
</div>

export const MonthlyAggregateGraph = (props: HighchartsReact.Props) => <div className="graph-container">
  <HighchartsReact
      highcharts={Highcharts}
      options={getOptions(props.data, true)}
      {...props}
  />
</div>

export const CompareMonthlyAggregateGraph = (props: HighchartsReact.Props) => <div className="graph-container">
  <HighchartsReact
      highcharts={Highcharts}
      options={getCompareOptions(props.data, props.selectedYear, true)}
      {...props}
  />
</div>